module.exports = __webpack_public_path__ + "img/生命力.89f897ee.png";